<div
	ucUniImpressionGA
	[uniId]="uniId()"
	[uniName]="uniName()"
	[ugSearchOrderPosition]="ugso()"
	[cleSearchOrderPosition]="cleso()"
	[product]="product()"
	class="flex items-start gap-6 mt-6"
>
	@if (image()) {
		<a
			ucUniProfileGA
			[eventTypes]="['click']"
			[uniId]="uniId()"
			[uniName]="uniName()"
			[ugSearchOrderPosition]="ugso()"
			[cleSearchOrderPosition]="cleso()"
			[product]="product()"
			[routerLink]="slug()"
			(click)="closeNav()"
			class="relative flex-shrink-0 hidden lg:h-20 lg:block lg:w-36"
			data-cy="nav-card-landscape-internal-image"
		>
			<img [ngSrc]="image() | cdn" fill alt="" class="absolute nav-image" />
		</a>
	}

	<div>
		<p>
			<a
				ucUniProfileGA
				[eventTypes]="['click']"
				[uniId]="uniId()"
				[uniName]="uniName()"
				[ugSearchOrderPosition]="ugso()"
				[cleSearchOrderPosition]="cleso()"
				[product]="product()"
				[routerLink]="slug()"
				(click)="closeNav()"
				class="navlink-black"
				data-cy="nav-card-landscape-internal-title"
				>{{ uniName() }}</a
			>
		</p>
		<p class="mt-1 mb-3 nav-description">
			{{ description() }}
			@if (showReviewButton()) {
				&middot;
				<uc-write-review-btn
					[universityId]="uniId()"
					[universityName]="uniName()"
					[universityUrl]="slug()"
					buttonText="Leave a review"
				/>
			}
		</p>
		<a
			ucUniProfileGA
			[eventTypes]="['click']"
			[uniId]="uniId()"
			[uniName]="uniName()"
			[ugSearchOrderPosition]="ugso()"
			[cleSearchOrderPosition]="cleso()"
			[product]="product()"
			[routerLink]="slug()"
			(click)="closeNav()"
			class="navlink-blue"
			data-cy="nav-card-landscape-internal-link"
		>
			{{ linkText() }}
			<uc-arrow-right-v3-svg />
		</a>
	</div>
</div>
